import React from "react"
import { Board } from "Types/board"
import { WeixinPlaces } from "Methods/place"

interface ComponentProps {
    ad_place: {
        name: string,
    },
    seq_id: number,
    channel?: {
        name: string
    },
}

const AdPlace = (props: ComponentProps) => {
    const {
        ad_place,
        seq_id,
        channel: { name: channelName = '' } = {}
    } = props
    // console.log(ad_place)
    let placeName = ""
    if (ad_place) {
        placeName = ad_place.name
    }
    if (channelName === '微信') {
        placeName = (WeixinPlaces.find(({ id }) => id === seq_id) as Board).name
    }

    return (
        <div>{placeName}</div>
    )
}

export default AdPlace
